export const frenchRivieraFourFacesProgram = {
  programKey: 'lazurowe-wybrzeze-cztery-oblicza-riwiery',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Lazurowe Wybrzeże - Cztery oblicza Riwiery',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Lazurowe Wybrzeże:',
  stickySubtitle: 'Cztery oblicza Riwiery',

  pageUrl:
    'https://coolturystki.pl/wycieczki/lazurowe-wybrzeze-cztery-oblicza-riwiery',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-na-lazurowe-wybrzeze-nicea-panorama-mvf81o8w.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-na-lazurowe-wybrzeze-nicea-panorama-mvf81o8w.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Lazurowe Wybrzeże'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '2026-10-21',
  },

  /* Termin: 29 kwietnia - 3 maja 2027. */
  tripIds: [32],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '32': {
      pilotId: 'krzysztof',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Bezpośredni lot grupowy z Warszawy',
          description:
            'Wspólna podróż rozpoczyna się na Lotnisku Chopina w Warszawie. Lecimy bezpośrednio do Nicei, a po zakończeniu programu wracamy bezpośrednim rejsem do Warszawy. Można także dolecieć własnym połączeniem i spotkać się z grupą na lotnisku lub w ustalonym miejscu.',
        },
        hotel: {
          title: 'Hotel 4★ w Cannes',
          description:
            'Cztery noclegi spędzamy w hotelu 4★ w Cannes, ze śniadaniami w cenie.',
        },
      },
    },
  },
}
